import cookie from 'cookie_js';

/**
 * @function inPunchoutSession
 * @memberof Promega.Util
 * @description Determines whether or not the site is currently being browsed in a punchout session.
 * @returns {Boolean}
*/
export default function inPunchoutSession() {
    return cookie.get("OrganizationId") !== undefined;
}
